import { render, staticRenderFns } from "./conversations.vue?vue&type=template&id=6f7230bf&scoped=true"
import script from "./conversations.vue?vue&type=script&lang=js"
export * from "./conversations.vue?vue&type=script&lang=js"
import style0 from "./conversations.vue?vue&type=style&index=0&id=6f7230bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7230bf",
  null
  
)

export default component.exports